module.exports = __webpack_public_path__ + "media/images/doklady-332ea4928ae4cb625c1375e0f5312f4c.png";